export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q04_b.d71085f3.png";